<div *ngIf="entity$ | async as entity">
  <app-query-composite-filter
    [entity]="entity"
    [value]="state.filter"
    (filterChange)="onFilterChange($event)"></app-query-composite-filter>
</div>
